import React, { FC, MouseEvent, ReactNode } from "react";
import Tooltip from "components/Tooltip/Tooltip";
import { CopyToClipboard as CopyToClipboardLib } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { CopyToClipboardButton } from "./CopyToClipboard.styles";

interface CopyToClipboardProps {
  children: ReactNode;
  text: string;
  // Accessible name for icon-only triggers.
  label?: string;
}

const CopyToClipboard: FC<CopyToClipboardProps> = ({
  children,
  text,
  label,
}) => {
  const { t } = useTranslation("common");

  const handleClickCopyToClipboardBtn = (
    event: MouseEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
    event.preventDefault();
  };

  return (
    <Tooltip body={t("common.copiedToClipboard")} openEvents={{ click: true }} $zIndex={9999}>
      <CopyToClipboardLib text={text}>
        <CopyToClipboardButton
          onClick={handleClickCopyToClipboardBtn}
          aria-label={label}
          title={label}
        >
          {children}
        </CopyToClipboardButton>
      </CopyToClipboardLib>
    </Tooltip>
  );
};

export default React.memo(CopyToClipboard);
